import { useFetchData } from "./useFetchData";
import queryKeys from "../configs/react-query/query-key";

const useProjectMembers = (projectSeq) => {
    const { data: membersResponse, isLoading, error, refetch } = useFetchData(
        [queryKeys.getMembersByProjectId, projectSeq],
        queryKeys.getMembersByProjectId,
        {
            method: "GET",
        },
        {
            projectSeq: projectSeq,
            pageSize: 100, // Get all members at once for dropdown
            startRow: 0,
        },
        {
            enabled: !!projectSeq,
            retry: false,
            refetchOnWindowFocus: false,
        },
    );

    // Transform members data for dropdown
    const membersData = membersResponse?.object?.map((member) => ({
        value: member.member?.userId || member.memberId,
        label: member.member?.userName || member.memberId,
        roleCdName: member.member?.roleCdName || "",
        deptCdName: member.member?.deptCdName || member.member?.companyCdName || "",
        email: member.member?.email || "",
        companyCdName: member.member?.companyCdName || "",
        position: member.member?.position || "",
        phoneNo: member.member?.phoneNo || "",
        cellNo: member.member?.cellNo || "",
        createdAt: member.createdAt || "",
        createrName: member.createrName || "",
    })) || [];

    return {
        membersData,
        isLoading,
        error,
        refetch,
    };
};

export default useProjectMembers; 